import { Action } from '@ngrx/store';
import { InboxModel, ReplyMessageModel } from '../../models/inbox.model';
import {MarkMailAsReadCommand, ReplyPlatformMailCommand} from '../../commands/inbox.command';
export const INVALIDATE_INBOX = '[Inbox] INVALIDATE_INBOX';

export class InvalidateInboxAction implements Action {
  readonly type = INVALIDATE_INBOX;
  constructor() {}
}


export const GET_INBOX_LABELS = '[PLATFORM_INBOX] GET_INBOX_LABELS';
export const GET_INBOX_LABELS_SUCCESS = '[PLATFORM_INBOX] GET_INBOX_LABELS_SUCCESS';
export const GET_INBOX_LABELS_FAILED = '[PLATFORM_INBOX] GET_INBOX_LABELS_FAILED';
export const OTHERS_MAIL_ALERT = '[OTHERS] MailAlert';
export const MY_MAIL_ALERT = '[PLATFORM_INBOX] MY_MAIL_ALERT';

export class GetInboxLabelsAction implements Action {
  readonly type = GET_INBOX_LABELS;

  constructor() {
  }
}
export class MyMailAlertAction implements Action {
  readonly type = MY_MAIL_ALERT;

  constructor(public payload: any) {
  }
}
export class GetInboxLabelsSuccessAction implements Action {
  readonly type = GET_INBOX_LABELS_SUCCESS;

  constructor(public inboxLabels: InboxModel[]) {
  }
}
export class GetInboxLabelsFailedAction implements Action {
  readonly type = GET_INBOX_LABELS_FAILED;

  constructor(public error: any) {
  }
}

export const GET_MAIL_BY_ID = '[PLATFORM_INBOX] GET_MAIL_BY_ID';
export const GET_MAIL_BY_ID_SUCCESS = '[PLATFORM_INBOX] GET_MAIL_BY_ID_SUCCESS';
export const GET_MAIL_BY_ID_FAILED = '[PLATFORM_INBOX] GET_MAIL_BY_ID_FAILED';

export class GetMailByIdAction implements Action {
  readonly type = GET_MAIL_BY_ID;

  constructor(public id:string) {
  }
}
export class GetMailByIdSuccessAction implements Action {
  readonly type = GET_MAIL_BY_ID_SUCCESS;

  constructor(public mail: any, public command: MarkMailAsReadCommand) {
  }
}
export class GetMailByIdFailedAction implements Action {
  readonly type = GET_MAIL_BY_ID_FAILED;

  constructor(public error: any) {
  }
}
export const SAVE_REPLY_MAIL = '[PLATFORM_INBOX] SAVE_REPLY_MAIL';
export const SAVE_REPLY_MAIL_SUCCESS = '[PLATFORM_INBOX] SAVE_REPLY_MAIL_SUCCESS';
export const SAVE_REPLY_MAIL_FAILED = '[PLATFORM_INBOX] SAVE_REPLY_MAIL_FAILED';

export class SaveReplyMailAction implements Action {
  readonly type = SAVE_REPLY_MAIL;

  constructor(public command:ReplyPlatformMailCommand,public currentMailId:string) {
  }
}
export class SaveReplyMailSuccessAction implements Action {
  readonly type = SAVE_REPLY_MAIL_SUCCESS;

  constructor(public mail: any) {
  }
}
export class SaveReplyMailFailedAction implements Action {
  readonly type = SAVE_REPLY_MAIL_FAILED;

  constructor(public error: any) {
  }
}



export const GET_ALL_RECEPIENTS = '[PLATFORM_INBOX] GET_ALL_RECEPIENTS';
export const GET_ALL_RECEPIENTS_SUCCESS = '[PLATFORM_INBOX] GET_ALL_RECEPIENTS_SUCCESS';
export const GET_ALL_RECEPIENTS_FAILED = '[PLATFORM_INBOX] GET_ALL_RECEPIENTS_FAILED';

export class GetAllRecepientsAction implements Action {
  readonly type = GET_ALL_RECEPIENTS;

  constructor() {
  }
}
export class GetAllRecepientsSuccessAction implements Action {
  readonly type = GET_ALL_RECEPIENTS_SUCCESS;

  constructor(public recepients: any) {
  }
}
export class GetAllRecepientsFailedAction implements Action {
  readonly type = GET_ALL_RECEPIENTS_FAILED;
  constructor(public error: any) {
  }
}


export type InboxActions = InvalidateInboxAction
  |GetInboxLabelsAction
  |GetInboxLabelsSuccessAction
  |GetInboxLabelsFailedAction
  |GetMailByIdAction
  |GetMailByIdSuccessAction
  |GetMailByIdFailedAction
  |SaveReplyMailAction
  |SaveReplyMailSuccessAction
  |SaveReplyMailFailedAction
  |GetAllRecepientsAction
  |GetAllRecepientsSuccessAction
  |GetAllRecepientsFailedAction
  |MyMailAlertAction
  ;

